import { FollowWithUser } from '../models';
import { FollowRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetFollowingUseCase {
  constructor(private followRepository: FollowRepository) {}

  async execute(userId: string, limit?: number, offset?: number): Promise<FollowWithUser[]> {
    logger.debug('GetFollowing', 'Fetching following', { userId });

    const following = await this.followRepository.getFollowing(userId, limit, offset);

    logger.debug('GetFollowing', 'Found following', { count: following.length });

    return following;
  }
}
